/**
 * Matches `getXpBarPercentFromProgress` in modules/exploreUnknownLeveling.js.
 * xpToNext is remaining XP to the next level, not the full level band width.
 */
export function exploreUnknownXpBarPercent(xpIntoLevel, xpToNext) {
  const into = Number(xpIntoLevel) || 0;
  const remaining = Number(xpToNext) || 0;
  if (remaining <= 0) return 100;
  const band = into + remaining;
  if (band <= 0) return 0;
  return Math.min(100, Math.max(0, (into / band) * 100));
}
